<div class="query-builder qv-cud">
  <div class="position-relative row form-group prop-elem">
    <label class="col-sm-6 col-form-label" for="cud-config-table-names">
      <span>{{ 'QUERY_VIEW_ACTION_CONFIGURATION' | translate }}</span>
      <i class="fa fa-info-circle field-info" showDelay="100" hideDelay="100" tooltipPosition="bottom"
        tooltipStyleClass="label-tooltip custom-tooltip-properties"
        pTooltip="{{ 'QUERY_VIEW_ACTION_CONFIGURATION_INFO' | translate }}"></i>
    </label>
    <div class="col-sm-6 value-container">
      <div class="border-box pl-1 pr-1 d-flex justify-content-between align-items-center flex-grow-1">
        <span class="tbl-name" id="cud-config-table-names">
          <span showDelay="100" hideDelay="100" tooltipPosition="top"
            tooltipStyleClass="label-tooltip custom-tooltip-properties" pTooltip="{{ tableNames }}">{{ tableNames
            }}</span>
        </span>
        <div>
          <button type="button" class="btn btn-sm qb-button p-0"
            [ngClass]="{ contentActive: tableNames && tableNames?.length }" (click)="openCudConfig()">
            <em class="pi pi-pencil"></em>
          </button>
        </div>
      </div>
      <div class="remove-cud-config" role="button" tabindex="0" (click)="deleteCudConfig()"
        *ngIf="tableNames && tableNames?.length && !disableField">
        <i class="pi pi-trash"></i>
      </div>
    </div>
  </div>
</div>

<p-dialog [(visible)]="showCudConfig" [closeOnEscape]="false" [modal]="true" [draggable]="false" [resizable]="false"
  [closable]="false" [style]="{ width: '85vw' }" appendTo="body" styleClass="query-builder-modal cud-config-modal"
  *ngIf="showCudConfig">
  <ng-template #header>
    <div class="d-flex justify-content-between w-100">
      <span class="dialog-header">{{ 'QUERY_VIEW_ACTION_CONFIGURATION' | translate }} :
        <span class="dialog-subheader">
          {{ formData?.name }}
        </span>
      </span>
      <div>
        <span (click)="closePopup()" (keyup.enter)="closePopup()" tabindex="1" aria-label="close popup">
          <i class="pi pi-times-circle close-icon"></i>
        </span>
      </div>
    </div>
  </ng-template>

  <p-tabs [(value)]="activeIndex">
    <p-tablist>
      <p-tab [value]="0">
        <div [ngClass]="{ 'tab-label-container first-tab': true, 'step-done': tableAliasValue.length > 0 }">
          <div class="header-btn">
            <ng-container>1</ng-container>
          </div>
          <p>{{ 'SEL_TBLS' | translate }}</p>
        </div>
      </p-tab>
      <p-tab [value]="1" [disabled]="tableAliasValue.length === 0">
        <div [ngClass]="{
            'tab-label-container': true,
            'br-left': activeIndex === 2,
            'br-right': activeIndex === 0,
            'step-done': isStep2Done()
          }">
          <div class="header-btn">
            <ng-container>2</ng-container>
          </div>
          <p>{{ 'MAP_FLDS' | translate }}</p>
        </div>
      </p-tab>
      <p-tab [value]="2" [disabled]="tableAliasValue.length === 0">
        <div [ngClass]="{ 'tab-label-container last-tab': true, 'step-done': isStep3Done() }">
          <div class="header-btn">3</div>
          <p>{{ 'ACT_AND_SEQS' | translate }}</p>
        </div>
      </p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="0">
        <div class="tbl-container">
          <div class="row">
            <div class="col-4 select-tbl-container">
              <div class="tbl-sec-1">
                <div class="tbl-header">
                  <span class="title">{{ 'ALL_TABLES' | translate }}
                    <i class="fa fa-info-circle tblInfo" showDelay="100" hideDelay="100" tooltipPosition="bottom"
                      tooltipStyleClass="label-tooltip custom-tooltip-properties"
                      pTooltip="{{ 'SEL_TBL_INFO' | translate }}">
                    </i>
                  </span>
                </div>
                <div class="tbl-body">
                  @for (row of tableOptions; track row) {
                  <div class="tbl-row">
                    <div class="table-col">
                      <span class="table-name">{{ row.name }}</span>
                    </div>
                    <div class="action-col">
                      <i class="pi pi-angle-double-right add-tbl-icon" (click)="addTableAlias(row)"
                        (keyup.enter)="addTableAlias(row)" tabindex="2" aria-label="Add table alias"></i>
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>
            <div class="col-8 selected-tbl-container">
              <div class="tbl-sec-2">
                <div class="tbl-header-1">
                  <span class="title">{{ 'SELECTED_TABLES' | translate }}
                    <i class="fa fa-info-circle tblInfo" showDelay="100" hideDelay="100" tooltipPosition="bottom"
                      tooltipStyleClass="label-tooltip custom-tooltip-properties"
                      pTooltip="{{ 'SELECTED_TBL_INFO' | translate }}">
                    </i>
                  </span>
                </div>
                <div class="tbl-header-2">
                  <span class="title table-name-col">{{ 'TABLE_NAME' | translate }}
                    <i class="fa fa-info-circle tblInfo" showDelay="100" hideDelay="100" tooltipPosition="bottom"
                      tooltipStyleClass="label-tooltip custom-tooltip-properties"
                      pTooltip="{{ 'SELECTED_TBL_INFO' | translate }}">
                    </i>
                  </span>
                  <span class="title alias-name-col">{{ 'ALIAS_NAME' | translate }}
                    <i class="fa fa-info-circle tblInfo" showDelay="100" hideDelay="100" tooltipPosition="bottom"
                      tooltipStyleClass="label-tooltip custom-tooltip-properties"
                      pTooltip="{{ 'ALIAS_TBL_INFO' | translate }}">
                    </i>
                  </span>
                  <span class="title action-col"></span>
                </div>
                <div class="tbl-body">
                  @for (row of tableAliasValue; track row; let i = $index) {
                  <div class="tbl-row">
                    <div class="table-name-col">
                      <span>{{ row.name }}</span>
                    </div>
                    <div class="alias-name-col">
                      <div class="alias-input-wrapper">
                        <div class="alias-input-with-ri">
                          <input type="text" pInputText [(ngModel)]="row.alias" [class.invalid]="row.isInvalid"
                            (input)="updateAlias(row, i)" (focusout)="onAliasFocusOut(row)" />
                          <span class="record-identifier-tag" *ngIf="row.recordIdentifierIndexName"
                            showDelay="100" hideDelay="100" tooltipPosition="top"
                            tooltipStyleClass="label-tooltip custom-tooltip-properties"
                            pTooltip="{{ row.recordIdentifierIndexName }}">
                            {{ row.recordIdentifierIndexName }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="action-col">
                      <button type="button" class="alias-menu-btn" (click)="openAliasMenu($event, row, i); aliasMenu.toggle($event)"
                        aria-label="Alias actions">
                        <i class="pi pi-ellipsis-v"></i>
                      </button>
                    </div>
                  </div>
                  }
                  @if (!tableAliasValue?.length) {
                  <div class="tbl-row">
                    <div class="no-records">
                      {{ 'NO_TABLES_SELECTED' | translate }}
                    </div>
                  </div>
                  }
                </div>
                <p-menu #aliasMenu [model]="aliasMenuItems" [popup]="true" appendTo="body" styleClass="alias-context-menu"></p-menu>
              </div>
            </div>
          </div>
        </div>
      </p-tabpanel>
      <p-tabpanel [value]="1">
        <div class="query-fields-table-container">
          <p-table *ngIf="queryFieldData" [value]="queryFieldData" responsiveLayout="scroll" [scrollable]="true"
            scrollHeight="84vh" styleClass="stepperTable" class="table" responsiveLayout="scroll">
            <ng-template #header let-columns>
              <tr>
                <th colspan="2" class="sticky-header" id="querFieldHeader">
                  <span class="body">{{ 'QRY_VW_FLD' | translate }}
                    <i class="fa fa-info-circle field-info tblInfo" showDelay="100" hideDelay="100"
                      tooltipPosition="bottom" tooltipStyleClass="label-tooltip custom-tooltip-properties"
                      pTooltsip="{{ 'QRY_FLD_INFO' | translate }}"></i>
                  </span>
                </th>
                <th colspan="3" class="sticky-header" id="querFieldMapHeader">
                  <span class="body">{{ 'FLD_MAPNG' | translate }}
                    <i class="fa fa-info-circle field-info tblInfo" showDelay="100" hideDelay="100"
                      tooltipPosition="bottom" tooltipStyleClass="label-tooltip custom-tooltip-properties"
                      pTooltip="{{ 'FLD_MAP_INFO' | translate }}"></i>
                  </span>
                </th>
              </tr>
            </ng-template>
            <ng-template #body let-column let-i="rowIndex">
              <tr class="map-field-row">
                <td colspan="2">
                  <div class="query-field-label">
                    <div class="label-container">
                      <span class="table-name">{{ column.name }}</span>
                      <span class="text-small" *ngIf="column.uniqueIdGenReq">{{
                        'EMPTY_GENERATE_UNIQUEID_LABEL' | translate
                        }}</span>
                    </div>

                    <div class="kebab-dropdown-wrapper">
                      <button type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                        class="ellipsis-dropdown-btn cursor-pointer settings">
                        <span *ngIf="column.type === 'String'" class="ellipsis-container">
                          <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                        </span>
                      </button>
                      <div tabindex="-1" role="menu" aria-hidden="true" class="kebab-dropdown-menu dropdown-menu">
                        <ul class="nav flex-column eva-v2-dropdown">
                          <li>
                            <p-checkbox [binary]="true" [name]="uniqueIdGenReq" styleClass="mr-1"
                              [(ngModel)]="column.uniqueIdGenReq" (click)="stopDropdownClose($event)"></p-checkbox>
                            <label class="header-text m-0" for="uniqueIdGenReq">
                              {{ 'EMPTY_GENERATE_UNIQUEID' | translate }}
                            </label>
                            <i class="fa fa-info-circle field-info tblInfo" showDelay="100" hideDelay="100"
                              tooltipPosition="bottom" tooltipStyleClass="label-tooltip custom-tooltip-properties"
                              pTooltip="{{ 'EMPTY_GENERATE_UNIQUEID_INFO' | translate }}">
                            </i>
                          </li>
                        </ul>
                      </div>
                      <i class="pi pi-arrow-right"></i>
                    </div>
                  </div>
                </td>
                <td colspan="3" style="height: auto; min-height: unset; max-height: unset">
                  <div class="cudmapping-treeselect-container">
                    <p-treeSelect [(ngModel)]="column.tfield" [options]="column.options" selectionMode="checkbox"
                      placeholder="{{ 'SELECT_FIELD' | translate }}" display="chip" [appendTo]="'body'"
                      (onNodeSelect)="onQueryMapfieldChange($event, column)" (onShow)="onOptionsShow(column)"
                      [metaKeySelection]="false">
                      <ng-template pTemplate="value" let-selectedValues>
                        <ng-container *ngIf="selectedValues === null || selectedValues?.length === 0">
                          {{ 'SELECT_FIELD' | translate }}
                        </ng-container>
                        <ng-container *ngIf="selectedValues?.length">
                          <div class="selected-values-container">
                            <p-chip *ngFor="let selectedValue of selectedValues"
                              label="{{ selectedValue.selectedLabel }}" [removable]="true"
                              (onRemove)="removeField(column.id, selectedValue.data)"></p-chip>
                          </div>
                        </ng-container>
                      </ng-template>
                      <ng-template pTemplate="empty">
                        {{ 'NO_FIELDS_WITH_SAME_DATATYPE' | translate }}
                      </ng-template>
                    </p-treeSelect>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-tabpanel>
      <p-tabpanel [value]="2">
        <p-carousel [value]="actionOrder" [numVisible]="numVisible" [numScroll]="3" [circular]="false"
          [responsiveOptions]="responsiveOptions" [styleClass]="'action-order-carousel'" [showNavigators]="showNavigators" [showIndicators]="false">
          <ng-template let-action #item>
            <div class="action-order-wrap">
              <div class="action-header">
                <p-checkbox [binary]="true" [inputId]="action" [name]="action" [disabled]="disableField"
                  styleClass="mr-1" [(ngModel)]="enabledActions[action].value"></p-checkbox>
                <label class="header-text" for="action">{{ enabledActions[action].name | translate }}
                  <i class="fa fa-info-circle field-info tblInfo" showDelay="100" hideDelay="100"
                    tooltipPosition="bottom" tooltipStyleClass="label-tooltip custom-tooltip-properties"
                    pTooltip="{{ enabledActions[action].name + '_INFO' | translate }}">
                  </i>
                </label>
              </div>
              <div class="p-order-height">
                <p-orderlist [value]="cudActionOrder[action]" (onReorder)="onReorder($event,action)" controlsPosition="right"
                  [(selection)]="selectedTables[action]" [disabled]="!(disableField || enabledActions[action]?.value)"
                  [dragdrop]="disableField || enabledActions[action]?.value">
                  <ng-template #header>
                    <div class="order-list-header">
                      <div class="reorder-container"></div>
                      <div class="table-name-container">
                        <span>{{ 'TABLE' | translate
                          }}<i class="fa fa-info-circle field-info tblInfo" showDelay="100" hideDelay="100"
                            tooltipPosition="bottom" tooltipStyleClass="label-tooltip custom-tooltip-properties"
                            pTooltip="{{ 'TBL_INFO' | translate }}"></i></span>
                      </div>
                      <div class="action-container">
                        <span>{{ 'ACTION' | translate
                          }}<i class="fa fa-info-circle field-info tblInfo" showDelay="100" hideDelay="100"
                            tooltipPosition="bottom" tooltipStyleClass="label-tooltip custom-tooltip-properties"
                            pTooltip="{{ 'ACTION_INFO' | translate }}"></i></span>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-value #item>
                    <div class="action-item">
                      <div class="reorder-container">
                        <i class="pi pi-bars"></i>
                      </div>
                      <div class="table-name-container">
                        <span class="table-name">
                          {{ value.label }}
                        </span>
                      </div>
                      <div [ngClass]="{'action-select': checkVisibility(value), 'no-action-select': !checkVisibility(value)}" class="action-container">
                        <div class="order-list-drp">
                          <p-select [options]="cudActions" (onChange)="resetQbId($event,value,action)"  (onFocus)="onActionFocus(value.action)"
                            placeholder="Select" optionLabel="name"
                            optionValue="value" appendTo="body" [(ngModel)]="value.action"
                            panelStyleClass="cud-action-dropdown-panel">
                          </p-select>
                        </div>
                        <div class="qb-icon-column" *ngIf="checkVisibility(value)">
                          <div class="cud-conditional-container">
                            <i class="fa fa-code-fork qb-icon" (click)="editqb(value,action)"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </p-orderlist>
              </div>
            </div>
          </ng-template>
        </p-carousel>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
      <div *ngIf="showQueryBuilder">
        <vb-vs-qb-builder
        [element]="conditionProperty"
        [(ngModel)]="conditional"
        (onSave)="changeQb($event)"
        (onClear)="clearQb($event)"
        [actionProp]="lastSelectedQbProp"
      >
      </vb-vs-qb-builder>
    </div>
  <ng-template #footer>
    <div class="d-flex w-100 justify-content-between">
      <div>
        <button type="button" (click)="prevStep()" class="btn btn-secondary cancel-btn d-flex align-items-center"
          *ngIf="activeIndex > 0">
          <span class="pi pi-angle-left mr-1 align-middle"></span>
          <span>{{ 'PREV' | translate }}</span>
        </button>
      </div>
      <div>
        <button type="button" class="btn btn-primary cancel-btn" (click)="closePopup()">
          {{ 'CANCEL' | translate }}
        </button>
        <button type="button" (click)="checkConcurrency()" class="btn btn-primary" [class.save-btn]="activeIndex < 2"
          [disabled]="
            (!isNewData() || tableAliasValue.length === 0 || disableField) &&
            !(tableAliasValue.length === 0 && isNewData())
          ">
          {{ (activeIndex < 2 ? 'SAVE' : 'SAVE_AND_CLOSE' ) | translate }} </button>
            <button type="button" (click)="nextStep()" [disabled]="tableAliasValue.length === 0"
              class="btn btn-secondary cancel-btn" icon="pi pi-angle-right" *ngIf="activeIndex < 2">
              <span>{{ 'NEXT' | translate }}</span>
              <span class="pi pi-angle-right ml-1 align-middle"></span>
            </button>
      </div>
    </div>
  </ng-template>

  <div class="spinner-container" *ngIf="isLoading">
    <p-progress-spinner></p-progress-spinner>
  </div>
</p-dialog>

<!-- Record Identifier Dialog -->
<vb-dialog [(visible)]="showRecordIdentifierDialog" [modal]="true"
  [closable]="true" size="medium" [closeOnEscape]="true"
  [styleClass]="'record-identifier-dialog'"
  (hide)="onRecordIdentifierDialogHide()"
  [header]="'SELECT_RECORD_IDENTIFIER_KEY' | translate">
  <div class="ri-dialog-content" *ngIf="selectedAliasForRI">
    <div class="ri-info-section">
      <i class="pi pi-info-circle ri-info-icon"></i>
      <span class="ri-info-text">{{ 'RECORD_IDENTIFIER_KEY_INFO' | translate }}</span>
    </div>
    <div class="ri-field-row">
      <label class="ri-label" for="ri-table-name">{{ 'TABLE_NAME' | translate }}</label>
      <input id="ri-table-name" type="text" pInputText [value]="selectedAliasForRI.name" [disabled]="true" class="ri-disabled-input" />
    </div>
    <div class="ri-field-row">
      <label class="ri-label" for="ri-alias-name">{{ 'ALIAS_NAME' | translate }}</label>
      <input id="ri-alias-name" type="text" pInputText [value]="selectedAliasForRI.alias" [disabled]="true" class="ri-disabled-input" />
    </div>
    <div class="ri-field-row">
      <label class="ri-label" for="ri-key-select">{{ 'RECORD_IDENTIFIER_KEY' | translate }}
        <i class="fa fa-info-circle tblInfo" showDelay="100" hideDelay="100" tooltipPosition="bottom"
          tooltipStyleClass="label-tooltip custom-tooltip-properties"
          pTooltip="{{ 'RECORD_IDENTIFIER_CLEAR_INFO' | translate }}"></i>
      </label>
      <p-select id="ri-key-select" [options]="availableIndexesForRI" [(ngModel)]="selectedIndexSidForRI"
        optionLabel="label" optionValue="sid"
        appendTo="body" [showClear]="true" styleClass="ri-select">
        <ng-template #selectedItem let-selectedOption>
          <span *ngIf="selectedOption">{{ selectedOption.label }}</span>
        </ng-template>
        <ng-template #item let-option>
          <div class="ri-option-item">
            <span class="ri-option-name">{{ option.label }}</span>
            <span class="ri-option-fields">{{ 'FIELDS' | translate }}: {{ option.fieldNames?.join(', ') }}</span>
          </div>
        </ng-template>
      </p-select>
    </div>
  </div>
  <ng-template #footerTemplate>
    <vb-button-group>
      <vb-button [label]="'CANCEL' | translate" variant="secondary" [outlined]="true"
        (btnClick)="onRecordIdentifierDialogHide()"></vb-button>
      <vb-button [label]="'APPLY' | translate" variant="primary"
        (btnClick)="applyRecordIdentifier()"></vb-button>
    </vb-button-group>
  </ng-template>
</vb-dialog>

<div class="spinner-container" *ngIf="isLoading">
  <p-progress-spinner></p-progress-spinner>
</div>